import React, { memo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { isElalCompany } from '@/utils/isCompany';
import ElalLoader from '@/img/elal-loader.gif';

const ELAL_GIF_SIZE = 80;

function LazyRecheckLoader({ visible }) {
    const { t } = useTranslation();

    if (!visible) return null;

    const isElal = isElalCompany();

    return (
        <div className="lazy-recheck-loader-overlay">
            <div className="lazy-recheck-loader-content">
                {isElal
                    ? <img src={ElalLoader} alt="" className="lazy-recheck-loader-gif" width={ELAL_GIF_SIZE} />
                    : <CircularProgress size={48} />
                }
                <Typography variant="h6" className="lazy-recheck-loader-text">
                    {t('LazyRecheckLoader.Message')}
                </Typography>
            </div>
        </div>
    );
}

export default memo(LazyRecheckLoader);
